var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "regist_input" } }, [
    _c("section", [
      _c("h2", [_vm._v("会員情報入力")]),
      _vm._v(" "),
      _c("div", { staticClass: "input_list" }, [
        _c("input", {
          staticStyle: { top: "-100px", left: "-100px", position: "fixed" },
          attrs: { type: "text" }
        }),
        _vm._v(" "),
        _c("input", {
          staticStyle: { top: "-100px", left: "-100px", position: "fixed" },
          attrs: { type: "password" }
        }),
        _vm._v(" "),
        _c(
          "ul",
          [
            !_vm.isPrivateUser
              ? _c("li", [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.span.corpType))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "important small_text" }, [
                      _vm._v("必須")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.userForm.corpType,
                          expression: "userForm.corpType",
                          modifiers: { number: true }
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return _vm._n(val)
                            })
                          _vm.$set(
                            _vm.userForm,
                            "corpType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.corpTypeList, function(type, index) {
                      return _c(
                        "option",
                        {
                          key: "corptype-" + index,
                          domProps: { value: type.code }
                        },
                        [_vm._v(_vm._s(type.label))]
                      )
                    })
                  ),
                  _vm._v(" "),
                  _vm.errors.corpType
                    ? _c("div", { staticClass: "error_text" }, [
                        _vm._v(_vm._s(_vm.errors.corpType))
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPrivateUser
              ? _c("li", [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.span.corpDept))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "important small_text" }, [
                      _vm._v("必須")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.userForm.corpDept,
                        expression: "userForm.corpDept",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: { type: "text", maxlength: "32" },
                    domProps: { value: _vm.userForm.corpDept },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userForm,
                          "corpDept",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.corpDept
                    ? _c("div", { staticClass: "error_text" }, [
                        _vm._v(_vm._s(_vm.errors.corpDept))
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "input_text2" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.span.userName))]),
                _vm._v(" "),
                _c("span", { staticClass: "important small_text" }, [
                  _vm._v("必須")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.userForm.userLastName,
                      expression: "userForm.userLastName",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { type: "text", placeholder: "家具", maxlength: "32" },
                  domProps: { value: _vm.userForm.userLastName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userForm,
                        "userLastName",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "space" }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.userForm.userFirstName,
                      expression: "userForm.userFirstName",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { type: "text", placeholder: "太郎", maxlength: "32" },
                  domProps: { value: _vm.userForm.userFirstName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userForm,
                        "userFirstName",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.errors.userName
                ? _c("div", { staticClass: "error_text" }, [
                    _vm._v(_vm._s(_vm.errors.userName))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "input_text2" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.span.userNameKana))]),
                _vm._v(" "),
                _c("span", { staticClass: "important small_text" }, [
                  _vm._v("必須")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.userForm.userLastNameKana,
                      expression: "userForm.userLastNameKana",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { type: "text", placeholder: "カグ", maxlength: "32" },
                  domProps: { value: _vm.userForm.userLastNameKana },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userForm,
                        "userLastNameKana",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "space" }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.userForm.userFirstNameKana,
                      expression: "userForm.userFirstNameKana",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "タロウ",
                    maxlength: "32"
                  },
                  domProps: { value: _vm.userForm.userFirstNameKana },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userForm,
                        "userFirstNameKana",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.errors.userNameKana
                ? _c("div", { staticClass: "error_text" }, [
                    _vm._v(_vm._s(_vm.errors.userNameKana))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.isEdit
              ? _c("li", [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.span.email))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "important small_text" }, [
                      _vm._v("必須")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.userForm.email,
                        expression: "userForm.email",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "****@domans.co.jp",
                      maxlength: "128",
                      disabled: !_vm.isEdit
                    },
                    domProps: { value: _vm.userForm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userForm,
                          "email",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "small_p caution_msg" }, [
                    _vm._v(
                      "※仮登録したアドレスと間違いがないかご確認ください。"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.errors.email
                    ? _c("div", { staticClass: "error_text" }, [
                        _vm._v(_vm._s(_vm.errors.email))
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEdit
              ? [
                  _c("li", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.span.password))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "important small_text" }, [
                        _vm._v("必須")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.userForm.password,
                          expression: "userForm.password",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "password",
                        maxlength: "20",
                        autocomplete: "new-password"
                      },
                      domProps: { value: _vm.userForm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userForm,
                            "password",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "small_p caution_msg" }, [
                      _vm._v(
                        "※半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.password
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.password))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.span.confirmPassword))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "important small_text" }, [
                        _vm._v("必須")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.userForm.confirmPassword,
                          expression: "userForm.confirmPassword",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "password",
                        maxlength: "20",
                        autocomplete: "new-password"
                      },
                      domProps: { value: _vm.userForm.confirmPassword },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userForm,
                            "confirmPassword",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.confirmPassword
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.confirmPassword))
                        ])
                      : _vm._e()
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEdit
              ? _c("li", [
                  _c("div", [_vm._v("mm/styleをどこで知りましたか？")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.userForm.infosrc,
                          expression: "userForm.infosrc",
                          modifiers: { number: true }
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return _vm._n(val)
                            })
                          _vm.$set(
                            _vm.userForm,
                            "infosrc",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          staticClass: "select_placeholder",
                          attrs: { value: "" }
                        },
                        [_vm._v("選択してください")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.infoSrcList, function(type, index) {
                        return _c(
                          "option",
                          {
                            key: "infosrc-" + index,
                            domProps: { value: type.code }
                          },
                          [_vm._v(_vm._s(type.label))]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.isRequestPayment
          ? _c("div", { staticClass: "notes" }, [
              _c("p", [_vm._v("※掛払い決済は審査後にご利用いただけます。")]),
              _vm._v(" "),
              _c("p", { staticClass: "indent" }, [
                _vm._v(
                  "審査結果は通常３営業日以内にメールでお知らせいたします。"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "indent" }, [
                _vm._v(
                  "審査完了まではカード決済、銀行振込でご利用いただけます。"
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28096795", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28096795","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/user/DcUserInfo.vue
// module id = null
// module chunks = 